import { drivelabels_v2 } from '@googleapis/drivelabels';
import { getLabelLifecycleStatus } from './label-lifecycle';

type Label = drivelabels_v2.Schema$GoogleAppsDriveLabelsV2Label;

export function isLabelDeletable(label: Label) {
  const status = getLabelLifecycleStatus(label);
  return status === 'DRAFT' || status === 'DISABLED';
}

export function hasUndeletableLabel(labels: Label[]) {
  return labels.some((label) => !isLabelDeletable(label));
}

export function hasDisabledLabel(labels: Label[]) {
  return labels.some((label) => getLabelLifecycleStatus(label) === 'DISABLED');
}
